import React from 'react';
import './Footer.css';
import Logo from './Logo';

const Footer = () => {
  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const navOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Info */}
          <div className="footer-brand-col">
            <div className="footer-logo-row" onClick={() => scrollTo('hero')}>
              <Logo />
              <div className="footer-brand-text">
                <span className="footer-brand-name">Trevox</span>
                <span className="footer-brand-sub">Technologies</span>
              </div>
            </div>

            <p className="footer-brand-desc">
              We design and engineer custom software, mobile apps, scalable cloud systems, and performance marketing campaigns for growing businesses.
            </p>

            <div className="footer-system-status">
              <span className="status-live-dot"></span>
              <span>All Systems & Cloud Services Operational</span>
            </div>
          </div>

          {/* Solutions Column */}
          <div className="footer-links-col">
            <h4 className="footer-col-title">Enterprise Solutions</h4>
            <ul className="footer-nav-list">
              <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollTo('services'); }}>Web App Engineering</a></li>
              <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollTo('services'); }}>Mobile App Development</a></li>
              <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollTo('services'); }}>Cloud & DevOps Architecture</a></li>
              <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollTo('services'); }}>Technical SEO Optimization</a></li>
              <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollTo('services'); }}>Meta & Performance Advertising</a></li>
              <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollTo('services'); }}>Commercial Photo & Video</a></li>
            </ul>
          </div>

          {/* Company Column */}
          <div className="footer-links-col">
            <h4 className="footer-col-title">Company & Advisory</h4>
            <ul className="footer-nav-list">
              <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollTo('about'); }}>About Trevox</a></li>
              <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollTo('about'); }}>Our Principles</a></li>
              <li><a href="#portfolio" onClick={(e) => { e.preventDefault(); scrollTo('portfolio'); }}>Case Studies</a></li>
              <li><a href="#evaluation" onClick={(e) => { e.preventDefault(); scrollTo('evaluation'); }}>Digital Maturity Audit</a></li>
              <li><a href="#tools" onClick={(e) => { e.preventDefault(); scrollTo('tools'); }}>Tech Stack Ecosystem</a></li>
              <li><a href="#feedback" onClick={(e) => { e.preventDefault(); scrollTo('feedback'); }}>Client Endorsements</a></li>
            </ul>
          </div>

          {/* Connect & HQ Column */}
          <div className="footer-links-col">
            <h4 className="footer-col-title">Corporate Connect</h4>
            <ul className="footer-nav-list">
              <li><a href="mailto:trevoxtech@gmail.com">trevoxtech@gmail.com</a></li>
              <li><a href="tel:+916369627698">+91 63696 27698</a></li>
              <li><a href="https://www.google.com/maps/search/?api=1&query=Erode" target="_blank" rel="noopener noreferrer">Erode, Tamil Nadu, India</a></li>
            </ul>

            <div className="footer-social-row">
              <a href="https://www.linkedin.com/in/trevox-tech-b2b004394" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="social-link-badge">
                LinkedIn
              </a>
              <a href="https://github.com/trevoxtech" target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="social-link-badge">
                GitHub
              </a>
              <a href="https://www.instagram.com/trevoxtech/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-link-badge">
                Instagram
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom-bar">
          <div className="copyright-text">
            {new Date().getFullYear()} Trevox Technologies in Strategic Collaboration with MarketIQ Solutions. All Rights Reserved.
          </div>
          <div className="footer-legal-links">
            <span>Enterprise Quality Guaranteed</span>
            <span>•</span>
            <span>Confidentiality Protected Under NDA</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
